var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 75,
    viewBox: "0 0 183 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.753 27.1355C156.761 26.9111 156.765 26.686 156.765 26.4603C156.765 11.8467 130.423 3.9872 109.795 3.9872C99.742 3.9872 92.9017 5.85405 88.5304 9.45981C80.2777 3.67652 67.896 0 54.0544 0C29.2078 0 0 11.8467 0 26.4604C0 32.4401 4.89049 37.9566 12.3715 42.3877C8.73155 45.5111 6.54738 49.1013 6.54738 52.9205C6.54738 64.7064 20.9728 68.1259 47.1048 74.3205C47.7172 74.4657 48.3361 74.6124 48.9613 74.7608C64.7644 74.7608 78.2752 69.0215 83.7304 60.913C94.0658 66.3192 109.076 69.7208 125.782 69.7208C156.957 69.7208 182.23 57.8741 182.23 43.2605C182.23 34.5594 172.085 30.4246 156.753 27.1355Z",
    fill: "#F2F1EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.da8ac092d5ae571c21aa1d3555867097.svg";
export { ForwardRef as ReactComponent };